/*
 * Copyright (c) 2025 curryfirm.com
 */

import * as constants from '../../constants.js';

/**
 * Fetch the UniqueLocationsLogged worksheet rows of the relevant Google Sheets document.
 * Use the column titles row to form a map of column name to column index.
 * Thus, if somebody changes the order of the columns in the Sheets doc, it won't break the app.
 * If he or she changes the title names, then things break.
 * @returns {Promise<*map, []|*>}
 */
const fetchUniqueLocationsLogged = async () => {
    const columnMap = {};
    const rowData = [];
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${constants.TRACKER_WORKBOOK_ID}/values/${constants.UNIQUE_LOCATIONS_LOGGED_RANGE}?key=${constants.TRACKER_WORKBOOK_API_KEY}`;
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Error fetching ${constants.UNIQUE_LOCATIONS_LOGGED_RANGE}: ${response.statusText}`);
    }

    const json = await response.json();

    if (!json.values || json.values.length === 0) {
        return {columnMap, rowData};
    }

    // Construct column index map from row[0]
    const headerRow = json.values[0];
    headerRow.forEach((title, index) => { columnMap[title] = index; });

    return { columnMap: columnMap, rows: json.values.slice(1) };
};

export default fetchUniqueLocationsLogged;
